var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSellout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 4.66663H3.33341C2.96522 4.66663 2.66675 4.96509 2.66675 5.33329V14C2.66675 14.3682 2.96522 14.6666 3.33341 14.6666H12.6667C13.0349 14.6666 13.3334 14.3682 13.3334 14V5.33329C13.3334 4.96509 13.0349 4.66663 12.6667 4.66663Z",
    stroke: "#2A3D4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66675 6.00004V3.66671C5.66675 2.37804 6.71141 1.33337 8.00008 1.33337C9.28875 1.33337 10.3334 2.37804 10.3334 3.66671V6.00004",
    stroke: "#2A3D4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 10L5.33325 10",
    stroke: "#2A3D4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66675 8L10.6667 10L8.66675 12",
    stroke: "#2A3D4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellout);
export default __webpack_public_path__ + "static/media/sellout.f86d267eaa96ceaf8d6616008dc94fe3.svg";
export { ForwardRef as ReactComponent };